import React from "react";

export default function Paralax1Svg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="214"
      height="197"
      viewBox="0 0 214 197"
      fill="none"
      {...props}
    >
      <g filter="url(#filter0_iif_1172_41447)">
        <path
          d="M25.8383 49.6061C19.2411 38.1794 27.4876 23.8961 40.6819 23.8961L173.704 23.8961C186.898 23.8961 195.145 38.1794 188.548 49.6061L122.037 164.807C115.439 176.233 98.9465 176.233 92.3493 164.807L25.8383 49.6061Z"
          fill="#282828"
        />
      </g>
      <defs>
        <filter
          id="filter0_iif_1172_41447"
          x="0.516357"
          y="0.895996"
          width="213.353"
          height="195.48"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="16" dy="-6" />
          <feGaussianBlur stdDeviation="9.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1172_41447"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-11" dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_1172_41447"
            result="effect2_innerShadow_1172_41447"
          />
          <feGaussianBlur
            stdDeviation="11.5"
            result="effect3_foregroundBlur_1172_41447"
          />
        </filter>
      </defs>
    </svg>
  );
}
